import { render, staticRenderFns } from "./AddComponent.vue?vue&type=template&id=d46ad1c4&scoped=true&"
import script from "./AddComponent.vue?vue&type=script&lang=js&"
export * from "./AddComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddComponent.vue?vue&type=style&index=0&id=d46ad1c4&prod&scoped=true&lang=css&"
import style1 from "./AddComponent.vue?vue&type=style&index=1&id=d46ad1c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46ad1c4",
  null
  
)

export default component.exports